import RoleManage from './roleManage.vue'
import Add from './add/add-routing'

export default [{
    path: '/lyRoleManage',
    name:'lyRoleManage',
    component:RoleManage,
    children:[...Add]
}]